/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { getInputClasses } from "../../../helpers/helper";
import * as userService from "../../../services/management/userService";
import * as alert from "../../../redux/alertSnackBarRedux";
import * as userProfile from "../../../redux/userProfileOverviewRedux";

function ChangePassword(props) {
  const { userProfileState, showAlert, history } = props;

  const [loading, setloading] = useState(false);

  const saveUser = (values, setStatus, setSubmitting) => {
    setloading(true);
    setSubmitting(true);
    userService.changeUserPassword(userProfileState.id, values.password).then(res => {
      showAlert({
        message: res.message,
        variant: "success"
      })
    }).catch(ex => {
      showAlert({
        message: ex.message,
        variant: "error"
      })
    }).finally(() => {
      setloading(false);
      setSubmitting(false);
    })
  };
  // UI Helpers
  const initialValues = {
    password: "",
    cPassword: "",
  };

  const Schema = Yup.object().shape({
    // currentPassword: Yup.string().required("Current password is required"),
    password: Yup.string().required("New Password is required").min(5, "Minimum length of Password is 5"),
    cPassword: Yup.string()
      .required("Password confirmation is required")
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Password and Confirm Password didn't match"
        ),
      }),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      saveUser(values, setStatus, setSubmitting);
    },
    onReset: (values, { resetForm }) => {
      resetForm();
    },
  });

  return (
    <form className="card card-custom" onSubmit={formik.handleSubmit}>
      {loading && <ModalProgressBar />}

      {/* begin::Header */}
      <div className="card-header py-3">
        <div className="card-title align-items-start flex-column">
          <h3 className="card-label font-weight-bolder text-dark">
            Change Password
          </h3>
          <span className="text-muted font-weight-bold fz-xs mt-1">
            Change account password
          </span>
        </div>
        <div className="card-toolbar">
          <button
            type="submit"
            className="btn btn-success mr-2"
            disabled={
              formik.isSubmitting || (formik.touched && !formik.isValid)
            }
          >
            Save Changes
            {formik.isSubmitting}
          </button>
          <a
            onClick={() => history.goBack()}
            className="btn btn-danger"
          >
            Cancel
          </a>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Form */}
      <div className="form">
        <div className="card-body">
          {/* <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600 text-alert">
              Current Password
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="password"
                placeholder="Current Password"
                className={`form-control form-control-lg form-control-solid mb-2 ${getInputClasses(
                  "currentPassword"
                )}`}
                name="currentPassword"
                {...formik.getFieldProps("currentPassword")}
              />
              {formik.touched.currentPassword &&
              formik.errors.currentPassword ? (
                <div className="invalid-feedback">
                  {formik.errors.currentPassword}
                </div>
              ) : null}
              <a href="#" className="text-sm font-weight-bold">
                Forgot password ?
              </a>
            </div>
          </div> */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600 text-alert">
              New Password
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="password"
                placeholder="New Password"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "password")}`}
                name="password"
                {...formik.getFieldProps("password")}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="invalid-feedback">{formik.errors.password}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600 text-alert">
              Verify Password
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="password"
                placeholder="Verify Password"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "cPassword")}`}
                name="cPassword"
                {...formik.getFieldProps("cPassword")}
              />
              {formik.touched.cPassword && formik.errors.cPassword ? (
                <div className="invalid-feedback">
                  {formik.errors.cPassword}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {/* end::Form */}
    </form>
  );
}

const mapStateToProps = (state) => ({
  userProfileState: state.userProfile
});

export default connect(mapStateToProps, {
  ...userProfile.actions,
  ...alert.actions
})(ChangePassword);

